import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-stats',
  templateUrl: './domain-stats.component.html',
  styleUrls: ['./domain-stats.component.scss']
})
export class DomainStatsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
